/**
 * useBrowsableChannels — `GET /api/channels/browse`.
 *
 * Returns the public channels the caller is NOT yet a member of. Drives
 * the `<BrowseChannelsModal>`. Cache key `['browsable-channels']` so the
 * channel-create / join / archive mutations can invalidate it surgically.
 */

import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/api/client'
import type { ChatBrowsableChannel } from '@/api/types-bridge'

export const BROWSABLE_CHANNELS_QUERY_KEY = ['browsable-channels'] as const

export function useBrowsableChannels(enabled = true) {
  return useQuery({
    queryKey: BROWSABLE_CHANNELS_QUERY_KEY,
    queryFn: async () => {
      const res = await apiClient<{ data: ChatBrowsableChannel[] }>('/api/channels/browse')
      return res.data
    },
    enabled,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
